import { atom } from "recoil"

export const AtomCurrentProfileUrl = atom({
    key:'ATOMCURPROFILEURL',
    default:''
})
  